import { CountryEnv } from "@type/index";

const _countryEnv: CountryEnv = {
  clientId: process.env.REACT_APP_CLIENT_ID_JP_PL || "pl.jp.new-styling-book",
  sbRootId: process.env.REACT_APP_FILTERS_SB_ROOT_ID_JP_PL || 22384,
  shRootId: process.env.REACT_APP_FILTERS_SH_ROOT_ID_JP_PL || 22385,
  firebaseApiKey: process.env.REACT_APP_FIREBASE_API_KEY_JP_PL || "",
  firebaseProjectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_JP_PL || "",
  firebaseAppId: process.env.REACT_APP_FIREBASE_APP_ID_JP_PL || "",
  firebaseMeasurementId:
    process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_JP_PL || "",
  storeDomain: process.env.REACT_APP_STORE_DOMAIN_PL || "",
  faqUrl: "https://faq.plst.com/",
  showAboutApp: true
};

export default _countryEnv;
